Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-cart-digital-care'), wrapper, model = null, IsDigitalCareSelected = false;

    if ($wrapper.length < 1) return;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.cartLoading = function loading(loading) {
        if (loading) {
           $('.x-cart').addClass('x-loading');
        } else {
            $('.x-cart').removeClass('x-loading');
        };
    };

    wrapper.update = function () {
        var html = Vendd.Handlebars.parse("cartDigitalCare_A", model);

        $wrapper.html(html);

        $wrapper.removeClass('x-initializing');
    };

    $wrapper.on('change', 'input[type="checkbox"]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($(this).is(':checked')) {
            IsDigitalCareSelected = true;
        } else {
            IsDigitalCareSelected = false;
        }

        wrapper.loading(true);
        wrapper.cartLoading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.SetDigitalCare(IsDigitalCareSelected));
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.Cart;

        wrapper.update();

        wrapper.loading(false);
        wrapper.cartLoading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetDigitalCareSuccess, wrapper, function (envelope) {
        wrapper.loading(false);
        wrapper.cartLoading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetDigitalCareFailure, wrapper, function (envelope) {
        wrapper.loading(false);
        wrapper.cartLoading(false);
    });

});